/**
 * @import { MediaLibraryService } from '$lib/types/private';
 */

/**
 * List of all the supported cloud storage services.
 * @type {Record<string, MediaLibraryService>}
 */
export const allCloudStorageServices = {
  //
};
